import { RANGE_DATE_FILTER_TYPES } from '../../constants/filter-criteria.constants';

export type FieldUiType =
  | 'text'
  | 'dropdown'
  | 'multiselect'
  | 'servicePartner'
  | 'date';

export interface FieldUiState {
  showTextInput: boolean;
  showDropdownfield: boolean;
  showMultiselect: boolean;
  showServicePartner: boolean;
  showDatePicker: boolean;
  showRangeDatePicker: boolean;
}

export function resolveFieldUiType(
  field: string,
  dropdownFields: Set<string>,
  multiselectFields: Set<string>,
  servicePartnerField: string,
): FieldUiType {
  const normalizedField = field?.trim().toLowerCase() || '';

  if (dropdownFields.has(normalizedField)) return 'dropdown';
  if (multiselectFields.has(normalizedField)) return 'multiselect';
  if (normalizedField === servicePartnerField) return 'servicePartner';
  if (normalizedField.endsWith(' date')) return 'date';

  return 'text';
}

export function buildFieldUiState(type: FieldUiType, field: string): FieldUiState {
  const normalizedField = field?.trim().toLowerCase() || '';

  return {
    showTextInput: type === 'text',
    showDropdownfield: type === 'dropdown',
    showMultiselect: type === 'multiselect',
    showServicePartner: type === 'servicePartner',
    showDatePicker: type === 'date',
    showRangeDatePicker:
      type === 'date' &&
      (normalizedField === RANGE_DATE_FILTER_TYPES.DeliveryDate ||
        normalizedField === RANGE_DATE_FILTER_TYPES.ContractDate),
  };
}
